"use strict";

class StationSettingsApplicationsDetailCtrl {
    constructor($rootScope, $mdToast, $http, $scope, $mdDialog, $state, widgets) {
        this.$rootScope = $rootScope;
        this.$mdToast = $mdToast;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$state = $state;
        this.widgets = widgets;
        this.applicationId = this.$state.params.applicationId;
        this.fetch();

        console.log('detailsconstr', this.$state.params);

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);
    }

    getModelTypes() {
        return this.$http.get("/modeltypes/item", {cache: true}).then((response) => {
            this.modelTypes = response.data.item;
        });
    }

    toggleModelType(widget, modelTypeId) {
        let index = widget.connected_modeltypes.indexOf(modelTypeId);
        if (index > -1) {
            widget.connected_modeltypes.splice(index, 1);
        } else {
            widget.connected_modeltypes.push(modelTypeId);
        }
    }

    isModelTypeSelected(widget, modelTypeId) {
        return widget.connected_modeltypes.indexOf(modelTypeId) > -1;
    }

    fetch() {
        this.$http.get('/applications/' + this.applicationId).then(response => {
            this.formdata = response.data;

            this.getModelTypes();
        });
    }

    checkActiveWidget(index) {
        return this.$state.params.widgetIndex == index;
    }

    openWidget(index) {
        this.$state.go('stationsettings.applications.manage.edit.widget', {widgetIndex: index});
    }

    openInstructions(widget, $event) {
        let button = angular.element(document.querySelector('.usage-instructions'));
        this.$mdDialog.show(
            {
                controller: 'usageInstructionsDialogCtrl',
                controllerAs: 'ctrl',
                templateUrl: "usageInstructionsDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: $event,
                hasBackdrop: true,
                clickOutsideToClose: true,
                escapeToClose: true,
                openFrom: button,
                closeTo: button,
                multiple: true,
                locals: {
                    widgetInstructions: widget.parsed_instructions,
                    widgetTitle: widget.title,
                }
            });
        console.log(widget);
    }

    save() {
        this.$http.patch('/applications/' + this.applicationId, this.formdata).then(() => {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=Widget',
                hideDelay: 6000,
                position: ('top right')
            });
            this.$rootScope.$broadcast('applicationsSaved');
            this.widgets.reloadWidgetsData();
            this.$state.reload();
            return true;
        })
        ;
    }
}


StationSettingsApplicationsDetailCtrl.$inject = [
    '$rootScope',
    '$mdToast',
    '$http',
    '$scope',
    '$mdDialog',
    '$state',
    'widgets'
];

module.exports = StationSettingsApplicationsDetailCtrl;
